
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { saveProviderToken } from "@/utils/emailUtils";
import { toast } from "sonner";
import { EmailProvider } from "@/types/email";

interface OutlookProviderSetupProps {
  provider?: EmailProvider;
  onUpdate: () => void;
}

const OutlookProviderSetup = ({ provider, onUpdate }: OutlookProviderSetupProps) => {
  const [outlookToken, setOutlookToken] = useState("");
  
  const handleSaveToken = () => {
    if (!outlookToken.trim()) {
      toast.error("Please enter an Outlook API token");
      return;
    }
    
    saveProviderToken("outlook", outlookToken);
    toast.success("Outlook API token saved");
    setOutlookToken("");
    onUpdate();
  };
  
  return (
    <div className="space-y-4">
      {provider?.isConnected && (
        <Alert>
          <AlertDescription>
            Outlook is connected. Last updated: {
              provider.lastTokenUpdate 
                ? new Date(provider.lastTokenUpdate).toLocaleString() 
                : "Unknown"
            }
          </AlertDescription>
        </Alert>
      )}
      
      <div className="space-y-2">
        <label className="text-sm font-medium">Outlook API Token</label>
        <Input
          type="password"
          value={outlookToken}
          onChange={(e) => setOutlookToken(e.target.value)}
          placeholder="Enter your Outlook API token"
        />
        <p className="text-xs text-muted-foreground">
          Your token will be stored locally in your browser only
        </p>
      </div>
      
      <Button onClick={handleSaveToken} className="w-full">
        {provider?.isConnected ? "Update Outlook Connection" : "Connect Outlook"}
      </Button>
    </div>
  );
};

export default OutlookProviderSetup;
